import { styled, Primitive } from '@miro-site/ui-styled-engine';
import { BREAKPOINTS_WIDTH_MAP } from '@miro-site/ui-styled-engine';
export var Container = styled(Primitive.div, {
  width: '100%',
  margin: 'auto',
  fromMd: {
    maxWidth: "".concat(BREAKPOINTS_WIDTH_MAP.md, "px")
  },
  fromLg: {
    maxWidth: "".concat(BREAKPOINTS_WIDTH_MAP.lg, "px")
  },
  fromXl: {
    maxWidth: "".concat(BREAKPOINTS_WIDTH_MAP.xl, "px")
  },
  fromXxl: {
    maxWidth: "".concat(BREAKPOINTS_WIDTH_MAP.xxl, "px")
  },
  variants: {
    disableGutter: {
      "false": {
        paddingX: '$150'
      }
    }
  },
  defaultVariants: {
    disableGutter: false
  }
});
Container.displayName = 'Container';
export default Container;